import React, {useRef, useState, useEffect} from "react";

type BlogDetailVideoPlayerProps = {
    videoUrl: string;
    autoPlay?: boolean;
    style?: React.CSSProperties;
};

export const BlogDetailVideoPlayer = ({
    videoUrl,
    autoPlay = false,
    style,
}: BlogDetailVideoPlayerProps) => {
    const videoRef = useRef(null);
    const [isPortrait, setIsPortrait] = useState<boolean>(false);

    useEffect(() => {
        const handleMetadataLoad = () => {
            const videoElement = videoRef.current;
            if (videoElement) {
                // Get video dimensions from metadata
                const {videoWidth, videoHeight} = videoElement;
                setIsPortrait(videoHeight > videoWidth);
            }
        };

        const videoElement = videoRef.current;
        if (videoElement) {
            videoElement.addEventListener("loadedmetadata", handleMetadataLoad);
        }

        return () => {
            // Clean up event listener
            if (videoElement) {
                videoElement.removeEventListener("loadedmetadata", handleMetadataLoad);
            }
        };
    }, []);

    return (
        <video
            ref={videoRef}
            controls
            autoPlay={autoPlay}
            muted={autoPlay}
            controlsList="nodownload"
            src={videoUrl}
            style={{
                width: "100%",
                height: isPortrait ? "457px" : "auto",
                backgroundColor: isPortrait ? "black" : "white",
                ...style,
            }}
            data-test-id={"video"}
        />
    );
};
